// exportJournalModal.jsx
import React from "react";
import { Modal, Row, Col, Timeline } from "antd";
import defaultAvatar from "../../../../assets/images/default-avatar.png";
const ExporterJournal = ({ isOpen, onClose }) => {
  return (
  <Modal
  title={
    <div style={{ textAlign: "center" }}>
      <h3
        style={{
          margin: 0,
          fontFamily: "Poppins",
          fontWeight: 600,
          fontSize: "28px",
          color: "#202224",
        }}
      >
        Journal d’activité
      </h3>
      <p
        style={{
          margin: "5px 0 0 0",
          fontFamily: "Poppins",
          fontWeight: 400,
          fontSize: "14px",
          color: "#7A7A7A",
        }}
      >
        Retrouvez ici toutes les actions effectuées de <span style={{
        fontFamily: "Poppins",
        fontWeight: 500,
        fontSize: "17px",
        color: "#2A2A2A",}}
          >Binta-Admin</span> 
      </p>
    </div>
  }
  open={isOpen}
  onCancel={onClose}
  footer={null}
  width={676}
  style={{ borderRadius: 10 }}
>
      <div
        style={{
          borderTop: "1px solid #FFFFFF",
          margin: "0 -1px 16px -16px",
          paddingTop: "16px",
        }}
      >
        <Row>
          <Col className="mb-2" style={{  }}>
          Samedi 19 Avril 2025 à 15:23
          </Col>

          <Col>
            <div
              style={{
                border: "0.5px solid #D7D7D7",
                borderRadius: "5px",
                backgroundColor: "#396AFC05",
                width: 645,
                height: 110,
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  marginLeft: "30px",
                  marginTop: "15px",
                }}
              >
                <img
                  src={defaultAvatar}
                  alt=""
                  style={{
                    width: 29,
                    height: 29,
                    borderRadius: "50%",
                    objectFit: "cover",
                  }}
                />
                <span
                  style={{
                    color: "#2A2A2A",
                    fontWeight: "500",
                    fontFamily: "Poppins",
                    fontSize: "14px",
                  }}
                >
                  Binta-Admin
                </span>
              </div>

              <div>
                <span
                  style={{
                    color: "#2A2A2A",
                    fontWeight: "400",
                    fontFamily: "Poppins",
                    fontSize: "12px",
                    marginLeft: "65px",
                  }}
                >
                  Action effectuée :
                </span>
                <span
                  style={{
                    color: "#959595",
                    fontWeight: "400",
                    fontFamily: "Poppins",
                    fontSize: "12px",
                  }}
                >
                  {" "}
                  Modification taux commission
                </span>
              </div>

              <span
                style={{
                  color: "#2A2A2A",
                  fontWeight: "400",
                  fontFamily: "Poppins",
                  fontSize: "12px",
                  marginLeft: "65px",
                }}
              >
                Détails supplémentaires :
              </span>
              <span
                style={{
                  color: "#959595",
                  fontWeight: "400",
                  fontFamily: "Poppins",
                  fontSize: "12px",
                }}
              >
                {" "}
                Taux Sénégal 2,5% --&gt; 2,8%
              </span>
            </div>
          </Col>
        </Row>
      </div>
       <div
        style={{
          borderTop: "1px solid #FFFFFF",
          margin: "0 -1px 16px -16px",
         
        }}
      >
        <Row>
          <Col className="mb-2" style={{  }}>
          Vendredi 19 Avril 2025 à 15:23
          </Col>

          <Col>
            <div
              style={{
                border: "0.5px solid #D7D7D7",
                borderRadius: "5px",
                backgroundColor: "#396AFC05",
                width: 645,
                height: 110,
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  marginLeft: "30px",
                  marginTop: "15px",
                }}
              >
                <img
                  src={defaultAvatar}
                  alt=""
                  style={{
                    width: 29,
                    height: 29,
                    borderRadius: "50%",
                    objectFit: "cover",
                  }}
                />
                <span
                  style={{
                    color: "#2A2A2A",
                    fontWeight: "500",
                    fontFamily: "Poppins",
                    fontSize: "14px",
                  }}
                >
                  Binta-Admin
                </span>
              </div>

              <div>
                <span
                  style={{
                    color: "#2A2A2A",
                    fontWeight: "400",
                    fontFamily: "Poppins",
                    fontSize: "12px",
                    marginLeft: "65px",
                  }}
                >
                  Action effectuée :
                </span>
                <span
                  style={{
                    color: "#959595",
                    fontWeight: "400",
                    fontFamily: "Poppins",
                    fontSize: "12px",
                  }}
                >
                  {" "}
                  Modification taux commission
                </span>
              </div>

              <span
                style={{
                  color: "#2A2A2A",
                  fontWeight: "400",
                  fontFamily: "Poppins",
                  fontSize: "12px",
                  marginLeft: "65px",
                }}
              >
                Détails supplémentaires :
              </span>
              <span
                style={{
                  color: "#959595",
                  fontWeight: "400",
                  fontFamily: "Poppins",
                  fontSize: "12px",
                }}
              >
                {" "}
                Taux Sénégal 2,5% --&gt; 2,8%
              </span>
            </div>
          </Col>
        </Row>
      </div>
    <div
        style={{
          borderTop: "1px solid #FFFFFF",
          margin: "0 -1px 16px -16px",
         
        }}
      >
        <Row>
          <Col className="mb-2" style={{  }}>
          Jeudi 19 Avril 2025 à 15:23
          </Col>

          <Col>
            <div
              style={{
                border: "0.5px solid #D7D7D7",
                borderRadius: "5px",
                backgroundColor: "#396AFC05",
                width: 645,
                height: 110,
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  marginLeft: "30px",
                  marginTop: "15px",
                }}
              >
                <img
                  src={defaultAvatar}
                  alt=""
                  style={{
                    width: 29,
                    height: 29,
                    borderRadius: "50%",
                    objectFit: "cover",
                  }}
                />
                <span
                  style={{
                    color: "#2A2A2A",
                    fontWeight: "500",
                    fontFamily: "Poppins",
                    fontSize: "14px",
                  }}
                >
                  Binta-Admin
                </span>
              </div>

              <div>
                <span
                  style={{
                    color: "#2A2A2A",
                    fontWeight: "400",
                    fontFamily: "Poppins",
                    fontSize: "12px",
                    marginLeft: "65px",
                  }}
                >
                  Action effectuée :
                </span>
                <span
                  style={{
                    color: "#959595",
                    fontWeight: "400",
                    fontFamily: "Poppins",
                    fontSize: "12px",
                  }}
                >
                  {" "}
                  Modification taux commission
                </span>
              </div>

              <span
                style={{
                  color: "#2A2A2A",
                  fontWeight: "400",
                  fontFamily: "Poppins",
                  fontSize: "12px",
                  marginLeft: "65px",
                }}
              >
                Détails supplémentaires :
              </span>
              <span
                style={{
                  color: "#959595",
                  fontWeight: "400",
                  fontFamily: "Poppins",
                  fontSize: "12px",
                }}
              >
                {" "}
                Taux Sénégal 2,5% --&gt; 2,8%
              </span>
            </div>
          </Col>
        </Row>
    </div>
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        marginTop: "20px",
      }}
    >
    <button type="button"className="btn btn-primary button">Télécharger.pdf</button>
    </div>
    </Modal>
  );
};

export default ExporterJournal;

